import React, { Component } from "react";
import AsideRightMenu from "../Dashboard/AsideRightMenu";
import { onChange, setIsRequired, setOptions, validateForm } from "../../utils";
import {
  addressProofType,
  cityList,
  countryList,
  entityTypeList,
  stateList,
  updateKyc,
  uploadAddressProof,
  uploadGstin,
  uploadPan,
} from "../../action/profile";
import Swal from "sweetalert2";
import constant from "../../constant";
import { Link, withRouter } from "react-router-dom";

class KycForm extends Component {
  constructor(props) {
    super(props);
    const details = props.details;
    this.state = {
      details: undefined,
      entityType: {
        name: "entityType",
        value: details ? details?.ENTITY_TYPE_ID : "",
        options: [],
        error: [],
        isRequired: true,
      },
      address: {
        name: "address",
        value: details ? details?.ADDRESS : "",
        options: [],
        error: [],
        isRequired: true,
      },

      country: {
        name: "country",
        value: details ? details?.COUNTRY_ID : "",
        options: [],
        error: [],
        isRequired: true,
      },
      state: {
        name: "state",
        value: details ? details?.STATE_ID : "",
        options: [],
        error: [],
        isRequired: true,
      },
      city: {
        name: "city",
        value: details ? details?.CITY_ID : "",
        options: [],
        error: [],
        isRequired: true,
      },
      pin: {
        name: "pin",
        value: details ? details?.PINCODE : "",
        options: [],
        error: [],
        isRequired: true,
      },
      addressProof: {
        name: "addressProof",
        value: details ? details?.ADDRESS_PROOF_TYPE_ID : "",
        options: [],
        error: [],
        isRequired: true,
      },
      uploadAddressProofType: {
        name: "uploadAddressProofType",
        value: details ? details?.UPLOAD_ADDRESS_PROOF : "",
        options: [],
        error: [],
        isRequired: false,
      },
      nameonPanCard: {
        name: "nameonPanCard",
        value: details ? details?.NAME_ON_PAN : "",
        options: [],
        error: [],
        isRequired: true,
      },
      panCardStatus: {
        name: "panCardStatus",
        value: details ? details?.PAN_CARD_STATUS : "",
        options: [],
        error: [],
        isRequired: true,
      },
      pan: {
        name: "pan",
        value: details ? details?.PAN_NUMBER : "",
        options: [],
        error: [],
        isRequired: true,
      },
      uploadPan: {
        name: "uploadPan",
        value: details ? details?.UPLOAD_PAN : "",
        options: [],
        error: [],
        isRequired: false,
      },
      gst: {
        name: "gst",
        value: details ? details?.GST : "",
        options: [],
        error: [],
        isRequired: true,
      },
      gstin: {
        name: "gstin",
        value: details ? details?.GSTIN : "",
        options: [],
        error: [],
        isRequired: true,
      },
      uploadGstinCertificate: {
        name: "uploadGstinCertificate",
        value: details ? details?.UPLOAD_GSTIN_CERTIFICATE : "",
        options: [],
        error: [],
        isRequired: false,
      },
      tanNumber: {
        name: "tanNumber",
        value: details ? details?.TAN_NUMBER : "",
        options: [],
        error: [],
        isRequired: false,
      },
    };
  }

  componentDidMount() {
    document.title = constant.title.KycForm;

    countryList()
      .then((res) => {
        if (res.status) {
          setOptions(this, this.state.country.name, res.result.list);
          // this.setState( {country:res.result.list} )
        } else {
          alert(res.error);
        }
      })
      .catch((err) => {
        alert(err);
      });
    entityTypeList()
      .then((res) => {
        if (res.status) {
          setOptions(this, this.state.entityType.name, res.result);
        } else {
          alert(res.error);
        }
      })
      .catch((err) => {
        alert(err);
      });
    addressProofType()
      .then((res) => {
        if (res.status) {
          setOptions(this, this.state.addressProof.name, res.result);
        } else {
          alert(res.error);
        }
      })
      .catch((err) => {
        alert(err);
      });

    if (this.props.details) {
      stateList(parseInt(this.props.details.COUNTRY_ID))
        .then((res) => {
          if (res.status) {
            setOptions(this, this.state.state.name, res.result.list);
          } else {
            alert(res.error);
          }
        })
        .catch((err) => {
          alert(err);
        });

      cityList(parseInt(this.props.details.STATE_ID))
        .then((res) => {
          if (res.status) {
            setOptions(this, this.state.city.name, res.result.list);
          } else {
            alert(res.error);
          }
        })
        .catch((err) => {
          alert(err);
        });
    }
  }

  onSubmit = (e) => {
    debugger;
    e.preventDefault();

    if (this.state.gst.value === "N") {
      setIsRequired(this, this.state.gstin.name, true);
    } else if (this.state.gst.value === "Y") {
      setIsRequired(this, this.state.gstin.name, false);
    }

    if (validateForm(this)) {
      const {
        entityType,
        address,
        country,
        state,
        pin,
        addressProof,
        uploadAddressProofType,
        nameonPanCard,
        pan,
        city,
        panCardStatus,
        uploadPan,
        gst,
        gstin,
        uploadGstinCertificate,
        tanNumber,
      } = this.state;
      const model = {
        ENTITY_TYPE_ID: entityType.value,
        ADDRESS: address.value,
        COUNTRY_ID: country.value,
        STATE_ID: state.value,
        CITY_ID: city.value,
        PINCODE: pin.value,
        ADDRESS_PROOF_TYPE_ID: addressProof.value,
        UPLOAD_ADDRESS_PROOF: uploadAddressProofType.value,
        NAME_ON_PAN: nameonPanCard.value,
        PAN_CARD_STATUS: panCardStatus.value,
        PAN_NUMBER: pan.value,
        UPLOAD_PAN: uploadPan.value,
        GST: gst.value,
        GSTIN: gstin.value,
        UPLOAD_GSTIN_CERTIFICATE: uploadGstinCertificate.value,
        TAN_NUMBER: tanNumber.value,
      };
      updateKyc(model).then((res) => {
        if (res.status) {
          Swal.fire({
            icon: "success",
            text: res.result.message,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.props.history.push(constant.component.Dashboard.url);
        } else {
          Swal.fire({
            icon: "error",
            text: res.error,
            timer: 1500,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      });
    }
  };

  onChange = (e) => {
    debugger;

    const { name, value } = e.target;
    if (value == "Y" && name == "gst") {
      this.setState({ gstin: { ...this.state.gstin, isRequired: false } });
      onChange(this, name, value);
    } else {
      onChange(this, name, value);
    }
  };

  onAddressProofUpload = (e) => {
    e.preventDefault();
    let model = new FormData();
    model.append("file", e.target.files[0]);
    uploadAddressProof(model).then((res) => {
      if (res.status) {
        console.log("SUCCESS");
        onChange(
          this,
          this.state.uploadAddressProofType.name,
          res.result.fileName
        );
      } else {
        alert(res.error);
      }
    });
  };

  onPanUpload = (e) => {
    e.preventDefault();
    let model = new FormData();
    model.append("file", e.target.files[0]);
    uploadPan(model).then((res) => {
      if (res.status) {
        console.log("SUCCESS");
        onChange(this, this.state.uploadPan.name, res.result.fileName);
      } else {
        alert(res.error);
      }
    });
  };

  onGSTINUpload = (e) => {
    e.preventDefault();
    let model = new FormData();
    model.append("file", e.target.files[0]);
    uploadGstin(model).then((res) => {
      if (res.status) {
        console.log("SUCCESS");
        onChange(
          this,
          this.state.uploadGstinCertificate.name,
          res.result.fileName
        );
      } else {
        alert(res.error);
      }
    });
  };

  componentDidUpdate(prevProsp, preState, snapshot) {
    if (preState.country.value != this.state.country.value) {
      stateList(parseInt(this.state.country.value))
        .then((res) => {
          if (res.status) {
            setOptions(this, this.state.state.name, res.result.list);
          } else {
            alert(res.error);
          }
        })
        .catch((err) => {
          alert(err);
        });
    }
    if (preState.state.value != this.state.state.value) {
      cityList(parseInt(this.state.state.value))
        .then((res) => {
          if (res.status) {
            setOptions(this, this.state.city.name, res.result.list);
          } else {
            alert(res.error);
          }
        })
        .catch((err) => {
          alert(err);
        });
    }
  }

  render() {
    const {
      entityType,
      address,
      country,
      state,
      city,
      pin,
      uploadAddressProofType,
      addressProof,
      panCardStatus,
      pan,
      uploadPan,
      gst,
      gstin,
      uploadGstinCertificate,
      tanNumber,
      nameonPanCard,
    } = this.state;
    console.log("uploadddd", this.props);
    const { details } = this.props;

    return (
      <React.Fragment>
        <section className="pricing-area padding-top-100px padding-bottom-80px">
          <div className="container">
            <div className="row">
              <div className="col-md-3 mt-3">
                <AsideRightMenu />
              </div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="breadcrumb-content d-flex flex-wrap justify-content-between align-items-center">
                      <ul className="list-items d-flex align-items-center">
                        <li className="active__list-item">
                          <Link
                            to={constant.component.Dashboard.url}
                            className="text-secondary"
                          >
                            Home
                          </Link>
                        </li>
                        <li className="active__list-item text-secondary">
                          <Link
                            to={constant.component.Dashboard.url}
                            className="text-secondary"
                          >
                            Dashboard
                          </Link>
                        </li>
                        <li className=" text-secondary">KYC FORM</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-12">
                    <div className="billing-form-item mb-0">
                      <div className="billing-title-wrap">
                        <h3 className="widget-title pb-0">KYC FORM</h3>
                        <div className="title-shape margin-top-5px"></div>
                      </div>
                      <div className="billing-content">
                        <div className="postjob-form-action">
                          <form onSubmit={this.onSubmit}>
                            <div className="row">
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Entity type{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      className={
                                        entityType?.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }
                                      name={entityType.name}
                                      value={entityType.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">
                                        Select Entity type
                                      </option>
                                      {entityType.options &&
                                        entityType.options.map(function (
                                          item,
                                          index
                                        ) {
                                          return (
                                            <option
                                              key={index}
                                              value={item.ENTITY_TYPE_ID}
                                            >
                                              {item.ENTITY_TYPE}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Address{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        address.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={address.name}
                                      value={address.value}
                                      onChange={this.onChange}
                                      placeholder="Enter Your Address"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Country{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      className={
                                        country.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }
                                      name={country.name}
                                      value={country.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">Select Country</option>
                                      {country.options &&
                                        country.options.map(function (
                                          item,
                                          index
                                        ) {
                                          return (
                                            <option
                                              key={index}
                                              value={item.COUNTRY_ID}
                                            >
                                              {item.COUNTRY}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    State{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      className={
                                        state.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }
                                      name={state.name}
                                      value={state.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">Select State</option>
                                      {state.options &&
                                        state.options.map(function (
                                          item,
                                          index
                                        ) {
                                          return (
                                            <option
                                              key={index}
                                              value={item.STATE_ID}
                                            >
                                              {item.STATE}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    City{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      className={
                                        city.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }
                                      name={city.name}
                                      value={city.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">Select City</option>
                                      {city.options &&
                                        city.options.map(function (
                                          item,
                                          index
                                        ) {
                                          return (
                                            <option
                                              key={index}
                                              value={item.CITY_ID}
                                            >
                                              {item.CITY}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Pin{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        pin.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={pin.name}
                                      value={pin.value}
                                      onChange={this.onChange}
                                      placeholder="Please Enter  Pincode"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Address Proof Type{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      className={
                                        addressProof.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }
                                      name={addressProof.name}
                                      value={addressProof.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">
                                        Select Address Proof Type
                                      </option>
                                      {addressProof.options &&
                                        addressProof.options.map(function (
                                          item,
                                          index
                                        ) {
                                          return (
                                            <option
                                              key={index}
                                              value={item.ADDRESS_PROOF_TYPE_ID}
                                            >
                                              {item.ADDRESS_PROOF_TYPE}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full ">
                                <div className="input-box">
                                  <label className="label-text">
                                    Upload Address Proof
                                  </label>
                                  <div className="form-group mb-0">
                                    <input
                                      className={
                                        uploadAddressProofType.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="file"
                                      name={uploadAddressProofType.name}
                                      onChange={this.onAddressProofUpload}
                                    />
                                    {details ? (
                                      <a
                                        target="_blank"
                                        href={`${process.env.REACT_APP_BASE_URL}/company/address-proof/${details.UPLOAD_ADDRESS_PROOF}`}
                                      >
                                        {details.UPLOAD_ADDRESS_PROOF}
                                      </a>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    PAN Card Status{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      className={
                                        panCardStatus.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }
                                      name={panCardStatus.name}
                                      value={panCardStatus.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="Y">
                                        I have company's PAN card
                                      </option>
                                      <option value="N">
                                        Applied for company's PAN card
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Name on PAN card{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        nameonPanCard.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      name={nameonPanCard.name}
                                      value={nameonPanCard.value}
                                      onChange={this.onChange}
                                      type="text"
                                      placeholder="Enter the name on PAN Card"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    PAN
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        pan.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      name={pan.name}
                                      value={pan.value}
                                      onChange={this.onChange}
                                      type="text"
                                      placeholder="Please enter PAN Number"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-4 column-lg-full ">
                                <div className="input-box">
                                  <label className="label-text">
                                    Upload PAN
                                  </label>
                                  <div className="form-group mb-0">
                                    <input
                                      className={
                                        uploadPan.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="file"
                                      name={uploadPan.name}
                                      onChange={this.onPanUpload}
                                    />
                                    {details ? (
                                      <a
                                        target="_blank"
                                        href={`${process.env.REACT_APP_BASE_URL}/company/pan/${details.UPLOAD_PAN}`}
                                      >
                                        {details.UPLOAD_PAN}
                                      </a>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    GST
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>

                                  <div className="form-group postjob-select-container">
                                    <select
                                      className={
                                        gst.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }
                                      name={gst.name}
                                      value={gst.value}
                                      onChange={this.onChange}
                                    >
                                      <option value=""> Select GST </option>
                                      <option value="N"> Registered </option>
                                      <option value="Y"> UnRegistered </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              {gst.value == "N" && (
                                <div className="col-lg-4 column-lg-full">
                                  <div className="input-box">
                                    <label className="label-text">
                                      GSTIN{" "}
                                      <span className="text-danger font-size-16">
                                        *
                                      </span>
                                    </label>
                                    <div className="form-group">
                                      <input
                                        className={
                                          gstin.error.length > 0
                                            ? "form-control is-invalid"
                                            : "form-control"
                                        }
                                        type="text"
                                        name={gstin.name}
                                        value={gstin.value}
                                        onChange={this.onChange}
                                        placeholder="Please enter GSTIN Number"
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                              {gst.value == "N" && (
                                <div className="col-lg-4 column-lg-full ">
                                  <div className="input-box">
                                    <label className="label-text">
                                      Upload GSTIN Certificate
                                    </label>
                                    <div className="form-group mb-0">
                                      <input
                                        className={
                                          uploadGstinCertificate.error.length >
                                          0
                                            ? "form-control is-invalid"
                                            : "form-control"
                                        }
                                        name={uploadGstinCertificate.name}
                                        onChange={this.onGSTINUpload}
                                        type="file"
                                      />
                                      {details ? (
                                        <a
                                          target="_blank"
                                          href={`${process.env.REACT_APP_BASE_URL}/company/gst-certificate/${details.UPLOAD_GSTIN_CERTIFICATE}`}
                                        >
                                          {details.UPLOAD_GSTIN_CERTIFICATE}
                                        </a>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    TAN Number
                                    {/* <span className='text-danger font-size-16'>*</span> */}
                                  </label>

                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      name={tanNumber.name}
                                      value={tanNumber.value}
                                      onChange={this.onChange}
                                      type="text"
                                      placeholder="Please enter TAN Number"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div class="row sq-db1">
                                <div class="col-lg-12 pl-4 sq-db1">
                                  <div class="btn-box mt-4 pl-1 sq-db1">
                                    <button
                                      type="submit"
                                      class="theme-btn border-0 sq-db1"
                                    >
                                      <i class="la la-plus sq-db1"> </i> Save
                                      Changes
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default withRouter(KycForm);
